<!--
 * Created Date: 2020-06-24 7:30:23 PM
 * Author: Liu Man <lm@hcttop.com>
 * -----
 * Last Modified: 2020-06-24, 7:30:23 PM
 * Modified By: Liu Man <lm@hcttop.com>
 * -----
 * Copyright (c) 2020-2020 hcttop
 * -----
 * HISTORY:
 * Date               By    Comments
 * ------------------ ----  ---------------------------------------------
 -->

<template>
  <div>
    <Header></Header>
    <div class="home">
      <home-content-carousel></home-content-carousel>
      <home-content-introduction></home-content-introduction>
      <home-content-step></home-content-step>
      <home-content-model></home-content-model>
      <home-content-professional v-if="false"></home-content-professional>
      <home-content-core-technology v-if="false"></home-content-core-technology>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import HomeContentCarousel from "../../components/Carousel";
import HomeContentIntroduction from "./HomeContentIntroduction";
import HomeContentCoreTechnology from "./HomeContentCoreTechnology";
import HomeContentProfessional from "./HomeContentProfessional";
import HomeContentModel from "./HomeContentModel";
import HomeContentStep from "./HomeContentStep";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    HomeContentCarousel,
    HomeContentIntroduction,
    HomeContentCoreTechnology,
    HomeContentProfessional,
    HomeContentStep,
    HomeContentModel
  }
  // metaInfo: {
  //   title: "我是hello头", // set a title
  //   meta: [
  //     {
  //       // set meta
  //       name: "keywords",
  //       content: "我是hello关键字"
  //     },
  //     {
  //       name: "description",
  //       content: "我是hello描述"
  //     }
  //   ]
  // }
};
</script>
